(function () {
  'use strict';

  let currentUser = null;
  let sessionCheckInterval = null;
  let lastLoginTime = 0;

  window.userData = window.userData || {};
  window.userFullyLoaded = false;

  window.signout = async function () {
    // console.log('[SESSION-MANAGER] signout() called');
    window.__netwrckLogoutStartedAt = Date.now();
    window.__netwrckLogoutBlockSessionSave = true;
    try {
      sessionStorage.setItem('netwrck_logout_pending', '1');
    } catch { /* Error ignored */ }
    try {
      await fetch('/api/logout', {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      currentUser = null;
      window.currentUser = null;
      window.userSecret = null;
      window.userData = {};
      window.userFullyLoaded = false;
      localStorage.removeItem('userData');
      localStorage.removeItem('userSecret');
      localStorage.removeItem('userIsSubscribed');
      localStorage.removeItem('userDataTimestamp');
      localStorage.removeItem('netwrck_user');

      deleteCookie('userData');
      deleteCookie('userSecret');
      deleteCookie('user_secret');
      deleteCookie('userIsSubscribed');
      deleteCookie('userDataTimestamp');

      // Update header/UI inline without reloading
      try {
        const loginEls = document.querySelectorAll(
          '.header-login-signup, .login-link, .signup-link'
        );
        const logoutEls = document.querySelectorAll('.header-login-signout');
        const accountEls = document.querySelectorAll(
          '.header-account, .account-link'
        );
        const subscribeEls = document.querySelectorAll('.header-subscribe');

        loginEls.forEach((el) => (el.style.display = ''));
        logoutEls.forEach((el) => (el.style.display = 'none'));
        accountEls.forEach((el) => (el.style.display = 'none'));
        subscribeEls.forEach((el) => (el.style.display = 'none'));

        // Close any open auth dialogs
        const loginDialog = document.getElementById('login-dialog');
        const signupDialog = document.getElementById('signup-dialog');
        if (loginDialog && loginDialog.open) loginDialog.close();
        if (signupDialog && signupDialog.open) signupDialog.close();
      } catch (e) {
        console.warn('[SESSION-MANAGER] UI update after logout failed:', e);
      }

      // Notify listeners of auth changes (components may react)
      window.dispatchEvent(new Event('authStateChanged'));

      // Do NOT reload; keep navigation inline per requirements
    } catch (error) {
      console.error('[SESSION-MANAGER] Logout error:', error);
      // Fallback: still avoid hard reload; surface state as logged-out
    }
  };

  // console.log('[SESSION-MANAGER] window.signout defined:', typeof window.signout === 'function');

  function setCookie(name, value, days) {
    const expires = days
      ? `; expires=${new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()}`
      : '';
    document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/; SameSite=Strict; Secure=${location.protocol === 'https:'}`;
  }

  function getCookie(name) {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let c = cookies[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  }

  function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
  }

  try {
    let restoredData = null;
    let restoredTimestamp = null;

    const storedUserData = localStorage.getItem('userData');
    const storedTimestamp = localStorage.getItem('userDataTimestamp');
    if (storedUserData) {
      const parsedData = JSON.parse(storedUserData);
      if (parsedData && parsedData.id && parsedData.secret) {
        restoredData = parsedData;
        restoredTimestamp = storedTimestamp;
        // console.log('[SESSION-MANAGER] Restored userData from localStorage');
      }
    }

    if (!restoredData) {
      const cookieUserData = getCookie('userData');
      const cookieTimestamp = getCookie('userDataTimestamp');
      if (cookieUserData) {
        const parsedData = JSON.parse(cookieUserData);
        if (parsedData && parsedData.id && parsedData.secret) {
          restoredData = parsedData;
          restoredTimestamp = cookieTimestamp;
          // console.log('[SESSION-MANAGER] Restored userData from cookies');

          localStorage.setItem('userData', cookieUserData);
          if (cookieTimestamp)
            localStorage.setItem('userDataTimestamp', cookieTimestamp);
        }
      }
    }

    if (restoredData) {
      if (window.userData && window.userData.id && window.userData.credits > 0) {
        Object.keys(restoredData).forEach(function(key) {
          if (window.userData[key] === undefined || window.userData[key] === null || window.userData[key] === '') {
            window.userData[key] = restoredData[key];
          }
        });
      } else if (window.userData && window.userData.id) {
        window.userData = Object.assign({}, restoredData, window.userData);
      } else {
        window.userData = restoredData;
      }

      if (window.userData.is_subscribed === undefined) {
        const storedSubscribed =
          localStorage.getItem('userIsSubscribed') ||
          getCookie('userIsSubscribed');
        window.userData.is_subscribed = storedSubscribed === 'true';
      }
      // console.log('[SESSION-MANAGER] Restored is_subscribed:', window.userData.is_subscribed);

      const hourAgo = Date.now() - 60 * 60 * 1000;
      if (restoredTimestamp && parseInt(restoredTimestamp) < hourAgo) {
        // console.log('[SESSION-MANAGER] Stored data is older than 1 hour, will refresh from server');
      }
    }
  } catch (e) {
    console.error(
      '[SESSION-MANAGER] Failed to restore userData from storage:',
      e
    );
  }

  async function checkAuthStatus() {
    // console.log('[SESSION-MANAGER] Checking auth status...');
    // console.log('[SESSION-MANAGER] Current cookies:', document.cookie);

    try {
      const requestStartedAt = Date.now();
      const secret =
        localStorage.getItem('userSecret') ||
        getCookie('userSecret') ||
        getCookie('user_secret') ||
        window.userSecret;

      const fetchUser = async (endpoint) => {
        const response = await fetch(endpoint, {
          method: 'GET',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
          },
        });
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          console.warn(
            '[SESSION-MANAGER] Non-JSON response from /api/get-user, content-type:',
            contentType
          );
          return { response, data: null };
        }
        const data = await response.json();
        return { response, data };
      };

      let { data } = await fetchUser('/api/get-user');
      if ((!data || !data.success) && secret) {
        ({ data } = await fetchUser(
          '/api/get-user?secret=' + encodeURIComponent(secret)
        ));
      }

      if (data && data.success && (data.data || data.user)) {
        if (
          (window.__netwrckLogoutStartedAt || 0) > requestStartedAt ||
          window.__netwrckLogoutStartedAt ||
          window.__netwrckLogoutBlockSessionSave
        ) {
          currentUser = null;
          updateUIForLoggedOutUser();
          return false;
        }
        currentUser = data.data || data.user;
        updateUIForLoggedInUser(currentUser);
        return true;
      }

      currentUser = null;
      updateUIForLoggedOutUser();
      return false;
    } catch (error) {
      console.error('[SESSION-MANAGER] Auth status check failed:', error);
      currentUser = null;
      updateUIForLoggedOutUser();
      return false;
    }
  }

  function updateUIForLoggedInUser(user) {
    lastLoginTime = Date.now();

    const loginElements = document.querySelectorAll('.header-login-signup');
    loginElements.forEach((el) => (el.style.display = 'none'));

    const logoutElements = document.querySelectorAll('.header-login-signout');
    logoutElements.forEach((el) => (el.style.display = 'block'));

    const accountElements = document.querySelectorAll('.header-account');
    // console.log('[SESSION-MANAGER] Found', accountElements.length, 'account elements to show');
    accountElements.forEach((el) => {
      // console.log('[SESSION-MANAGER] Showing account element:', el);
      el.style.display = 'block';
    });

    const subscribeButtons = document.querySelectorAll('.header-subscribe');
    // console.log('[SESSION-MANAGER] Found', subscribeButtons.length, 'subscribe buttons');
    // console.log('[SESSION-MANAGER] User is_subscribed:', user.is_subscribed);
    subscribeButtons.forEach((el, index) => {
      const displayValue = user.is_subscribed ? 'none' : 'block';
      el.style.display = displayValue;
      // console.log(`[SESSION-MANAGER] Subscribe button ${index + 1} display:`, displayValue);
      // console.log(`[SESSION-MANAGER] Subscribe button ${index + 1} classes:`, el.className);
      // console.log(`[SESSION-MANAGER] Subscribe button ${index + 1} current display:`, el.style.display);
    });

    const subscribeDialog = document.getElementById('subscribe-dialog');
    if (subscribeDialog) {
      // console.log('[SESSION-MANAGER] Found subscribe dialog, ensuring correct display for logged-in user');

      const loginSection = subscribeDialog.querySelector(
        '.header-login-signup'
      );
      if (loginSection) {
        loginSection.style.display = 'none';
        // console.log('[SESSION-MANAGER] Hidden login section in subscribe dialog');
      }

      const stripeSection = subscribeDialog.querySelector(
        '#stripe-checkout-dialog-content'
      );
      if (stripeSection) {
        stripeSection.style.display = 'block';
        // console.log('[SESSION-MANAGER] Shown Stripe section in subscribe dialog');

        if (subscribeDialog.open && stripeSection.innerHTML.trim() === '') {
          // console.log('[SESSION-MANAGER] Subscribe dialog is open but Stripe content is empty, attempting to load');
          if (window.setupStripe && typeof window.setupStripe === 'function') {
            window.setupStripe().catch((error) => {
              console.error(
                '[SESSION-MANAGER] Error setting up Stripe:',
                error
              );
              stripeSection.innerHTML =
                '<div style="padding: 20px; text-align: center;"><p>Error loading payment form. Please try again.</p></div>';
            });
          }
        }
      }
    }

    window.currentUser = user;
    window.userSecret = user.secret;

    window.userData = {
      id: user.id,
      secret: user.secret,
      name: user.name || user.email?.split('@')[0] || 'User',
      email: user.email,
      uid: user.id,
      photoURL: user.photo_url || user.avatar_photo_url || null,
      photo_url: user.photo_url,
      avatar_photo_url: user.avatar_photo_url,
      is_subscribed: user.is_subscribed || false,
      subscription_status: user.subscription_status || null,
      description: user.description || null,
      greeting: user.greeting || null,
      profile_url: user.profile_url || null,
      free_credits: user.free_credits || 0,
      visibility: user.visibility || 'PUBLIC',
      created: user.created || null,

      ...user,
    };

    window.userFullyLoaded = true;

    // console.log('[SESSION-MANAGER] userData populated:', window.userData);
    // console.log('[SESSION-MANAGER] userData.id is:', window.userData.id);
    // console.log('[SESSION-MANAGER] typeof userData.id:', typeof window.userData.id);
    // console.log('[SESSION-MANAGER] userData.secret is:', window.userData.secret);

    window.dispatchEvent(new Event('authStateChanged'));

    try {
      const userDataJson = JSON.stringify(window.userData);
      const timestamp = Date.now().toString();
      const isSubscribedStr = window.userData.is_subscribed ? 'true' : 'false';

      localStorage.setItem('userData', userDataJson);
      localStorage.setItem('userSecret', window.userData.secret || '');
      localStorage.setItem('userIsSubscribed', isSubscribedStr);
      localStorage.setItem('userDataTimestamp', timestamp);

      setCookie('userData', userDataJson, 30);
      setCookie('userSecret', window.userData.secret || '', 30);
      setCookie('user_secret', window.userData.secret || '', 30);
      setCookie('userIsSubscribed', isSubscribedStr, 30);
      setCookie('userDataTimestamp', timestamp, 30);

      // console.log('[SESSION-MANAGER] Stored userData in localStorage and cookies');
      // console.log('[SESSION-MANAGER] is_subscribed:', window.userData.is_subscribed);
    } catch (e) {
      console.error(
        '[SESSION-MANAGER] Failed to store userData in storage:',
        e
      );
    }

    const subscribeUidElements = document.querySelectorAll('.subscribe-uid');
    subscribeUidElements.forEach((el) => (el.value = user.id));

    const subscribeSecretElements =
      document.querySelectorAll('.subscribe-secret');
    subscribeSecretElements.forEach((el) => (el.value = user.secret));

    const checkoutButtons = document.querySelectorAll('.checkout-button');
    checkoutButtons.forEach((el) => (el.disabled = false));

    window.dispatchEvent(new CustomEvent('userLoggedIn', { detail: user }));

    if (window.jQuery) {
      window.jQuery(document).trigger('user-ready', window.userData);
    }
    window.dispatchEvent(new CustomEvent('userLoggedIn', { detail: user }));
  }

  function updateUIForLoggedOutUser() {
    if (Date.now() - lastLoginTime < 5000) {
      return;
    }

    if (window.userData && window.userData.id) {
      return;
    }

    const loginElements = document.querySelectorAll('.header-login-signup');
    loginElements.forEach((el) => (el.style.display = 'block'));

    const logoutElements = document.querySelectorAll('.header-login-signout');
    logoutElements.forEach((el) => (el.style.display = 'none'));

    const accountElements = document.querySelectorAll('.header-account');
    accountElements.forEach((el) => (el.style.display = 'none'));

    const subscribeButtons = document.querySelectorAll('.header-subscribe');
    subscribeButtons.forEach((el) => (el.style.display = 'none'));

    const subscribeDialog = document.getElementById('subscribe-dialog');
    if (subscribeDialog) {
      // console.log('[SESSION-MANAGER] Found subscribe dialog, ensuring correct display for logged-out user');

      const loginSection = subscribeDialog.querySelector(
        '.header-login-signup'
      );
      if (loginSection) {
        loginSection.style.display = 'block';
        // console.log('[SESSION-MANAGER] Shown login section in subscribe dialog');
      }

      const stripeSection = subscribeDialog.querySelector(
        '#stripe-checkout-dialog-content'
      );
      if (stripeSection) {
        stripeSection.style.display = 'none';
        stripeSection.innerHTML = '';
        // console.log('[SESSION-MANAGER] Hidden Stripe section in subscribe dialog');
      }
    }

    window.currentUser = null;
    window.userSecret = null;

    window.userData = {};
    window.userFullyLoaded = false;

    try {
      localStorage.removeItem('userData');
      localStorage.removeItem('userSecret');
      localStorage.removeItem('userIsSubscribed');
      localStorage.removeItem('userDataTimestamp');
      localStorage.removeItem('netwrck_user');
      deleteCookie('userData');
      deleteCookie('userSecret');
      deleteCookie('user_secret');
      deleteCookie('userIsSubscribed');
      deleteCookie('userDataTimestamp');
      // console.log('[SESSION-MANAGER] Cleared userData from localStorage and cookies');
    } catch (e) {
      console.error('[SESSION-MANAGER] Failed to clear storage:', e);
    }

    const subscribeUidElements = document.querySelectorAll('.subscribe-uid');
    subscribeUidElements.forEach((el) => (el.value = ''));

    const subscribeSecretElements =
      document.querySelectorAll('.subscribe-secret');
    subscribeSecretElements.forEach((el) => (el.value = ''));

    const checkoutButtons = document.querySelectorAll('.checkout-button');
    checkoutButtons.forEach((el) => (el.disabled = true));

    window.dispatchEvent(new CustomEvent('userLoggedOut'));
  }

  function setupFormHandler(formId, successCallback) {
    const form = document.getElementById(formId);
    if (!form) {
      return;
    }

    if (form.dataset.bound === 'true' || form.dataset.sessionManagerBound === 'true') {
      return;
    }
    form.dataset.sessionManagerBound = 'true';

    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const formData = new FormData(form);
      const submitBtn = form.querySelector('button[type="submit"]');
      const errorElement = form.querySelector('.mdl-textfield__error');

      if (submitBtn) submitBtn.disabled = true;
      if (errorElement) errorElement.textContent = '';

      const jsonData = {};
      for (let [key, value] of formData.entries()) {
        jsonData[key] = value;
      }

      // console.log('[SESSION-MANAGER] Submitting form to:', form.action);
      // console.log('[SESSION-MANAGER] Form data:', jsonData);
      // console.log('[SESSION-MANAGER] JSON body:', JSON.stringify(jsonData));

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(jsonData),
          credentials: 'include',
        });

        if (response.ok) {
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            const data = await response.json();

            if (data.success || (data.id && data.email)) {
              // console.log('[SESSION-MANAGER] Login successful, response:', data);
              window.__netwrckLogoutStartedAt = 0;
              window.__netwrckLogoutBlockSessionSave = false;
              try {
                sessionStorage.removeItem('netwrck_logout_pending');
              } catch { /* Error ignored */ }

              const dialog = form.closest('dialog');
              if (dialog) dialog.close();

              if (data.id && !data.data) {
                const userData = {
                  id: data.id,
                  email: data.email,
                  username: data.username,
                  secret: data.api_key,
                  is_subscribed: data.is_subscribed,
                  credits: data.credits,
                  free_credits: data.free_credits,
                  paid_credits: data.paid_credits,
                };
                updateUIForLoggedInUser(userData);
              }

              await checkAuthStatus();

              setTimeout(() => {
                if (window.currentUser) {
                  updateUIForLoggedInUser(window.currentUser);

                  const subscribeButtons =
                    document.querySelectorAll('.header-subscribe');
                  // console.log('[SESSION-MANAGER] Force update - Found', subscribeButtons.length, 'subscribe buttons');
                  subscribeButtons.forEach((el, index) => {
                    const displayValue = window.currentUser.is_subscribed
                      ? 'none'
                      : 'block';
                    el.style.display = displayValue;

                    if (!window.currentUser.is_subscribed) {
                      el.style.visibility = 'visible';
                      el.style.opacity = '1';
                    }
                    // console.log(`[SESSION-MANAGER] Force update - Subscribe button ${index + 1}:`, displayValue);
                  });
                }
              }, 100);

              if (successCallback) successCallback(data);
              else if (data.redirect) window.location.href = data.redirect;

              return;
            } else {
              if (errorElement) {
                errorElement.textContent =
                  data.error || 'Login failed. Please try again.';
              }
              return;
            }
          }
        }

        const errorText = await response.text();
        if (errorElement) {
          errorElement.textContent = errorText.includes('error')
            ? errorText
            : 'Login failed. Please try again.';
        }
      } catch (error) {
        console.error('Form submission error:', error);
        if (errorElement) {
          errorElement.textContent = 'Network error. Please try again.';
        }
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    console.log('Session-manager.js: DOM Content Loaded');

    checkAuthStatus();

    sessionCheckInterval = setInterval(checkAuthStatus, 5 * 60 * 1000);

    setTimeout(() => {
      setupFormHandler('auth-form');
      setupFormHandler('signup-form');
    }, 100);

    const logoutLinks = document.querySelectorAll('a[href="/logout"]');
    logoutLinks.forEach((link) => {
      link.addEventListener('click', async function (e) {
        e.preventDefault();
        // console.log('[SESSION-MANAGER] Logout link clicked');
        await window.signout();
      });
    });
  });

  window.addEventListener('beforeunload', function () {
    if (sessionCheckInterval) {
      clearInterval(sessionCheckInterval);
    }
  });

  window.authSession = {
    getCurrentUser: () => {
      // console.log('[SESSION-MANAGER] getCurrentUser called, returning:', currentUser);
      return currentUser;
    },
    checkStatus: checkAuthStatus,
    isLoggedIn: () => {
      const loggedIn = !!currentUser;
      // console.log('[SESSION-MANAGER] isLoggedIn called, currentUser:', currentUser, 'returning:', loggedIn);
      return loggedIn;
    },
    getUserSecret: () => {
      const secret = currentUser ? currentUser.secret : null;
      // console.log('[SESSION-MANAGER] getUserSecret called, returning:', secret);
      return secret;
    },
    getUserId: () => {
      const id = currentUser ? currentUser.id : null;
      // console.log('[SESSION-MANAGER] getUserId called, returning:', id);
      return id;
    },
    isSubscribed: () => {
      if (currentUser && currentUser.is_subscribed !== undefined) {
        return currentUser.is_subscribed;
      }
      if (window.userData && window.userData.is_subscribed !== undefined) {
        return window.userData.is_subscribed;
      }

      const storedSubscribed = localStorage.getItem('userIsSubscribed');
      return storedSubscribed === 'true';
    },
  };

  window.logout = window.signout;

  window.getUserData = function () {
    if (currentUser) {
      return {
        id: currentUser.id,
        email: currentUser.email,
        secret: currentUser.secret || currentUser.api_key,
        is_subscribed: currentUser.is_subscribed || false,
        credits: currentUser.credits || currentUser.free_credits || 0,
        name: currentUser.name || currentUser.username || currentUser.email,
      };
    }

    if (window.userData && window.userData.id) {
      return window.userData;
    }

    try {
      const stored = localStorage.getItem('userData');
      if (stored) {
        const parsed = JSON.parse(stored);
        if (parsed && parsed.id) {
          return parsed;
        }
      }
    } catch {
      /* Error ignored */
    }

    return null;
  };

  window.isUserSubscribed = function () {
    const userData = window.getUserData();
    if (userData) {
      return userData.is_subscribed === true;
    }
    return false;
  };

  if (typeof window.showTopupCreditsModal !== 'function') {
    window.showTopupCreditsModal = function (options) {
      const amount = (options && options.amount) || 25;
      const dialog =
        document.getElementById('topup-credits-dialog') ||
        document.getElementById('credits-checkout-dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        try {
          dialog.showModal();
          return;
        } catch {
          /* Error ignored */
        }
      }

      if (
        window.EmbeddedCheckout &&
        typeof window.EmbeddedCheckout.open === 'function'
      ) {
        window.EmbeddedCheckout.open({ amount, type: 'credits' });
        return;
      }

      window.location.href = '/account';
    };
  }

  document.addEventListener(
    'click',
    function (e) {
      const topupLink =
        e.target &&
        (e.target.id === 'topup-credits-link' ||
          (e.target.closest && e.target.closest('#topup-credits-link')));
      if (topupLink) {
        e.preventDefault();
        e.stopPropagation();

        const dialog =
          document.getElementById('topup-credits-dialog') ||
          document.getElementById('credits-checkout-dialog');
        if (dialog && typeof dialog.showModal === 'function') {
          try {
            dialog.showModal();
            return;
          } catch {
            /* Error ignored */
          }
        }

        if (
          window.EmbeddedCheckout &&
          typeof window.EmbeddedCheckout.open === 'function'
        ) {
          window.EmbeddedCheckout.open({ amount: 25, type: 'credits' });
          return;
        }

        if (typeof window.showTopupCreditsModal === 'function') {
          try {
            window.showTopupCreditsModal({ amount: 25 });
            return;
          } catch {
            /* Error ignored */
          }
        }
        window.location.href = '/account';
      }
    },
    true
  );
})();
